import { getCapabilityConfigByValueType } from './capabilityDynamicFieldsConfig';

/**
 * Reconstructs capabilityDynamicFields for the selected capability's type (edit/restore), if it uses dynamic fields.
 * Delegates to the type's `toUi` from CAPABILITY_DYNAMIC_FIELDS_CONFIG. items/deviceId let `toUi` resolve field
 * existence (e.g. the PIN key against user_codes) once, at restore time.
 * @param {Object} selectedCapability - restored capability item
 * @param {Object} block - saved when-block (source of fields)
 * @param {Array} items - controller items
 * @param {string} deviceId - device id
 * @returns {Object|undefined} capabilityDynamicFields, or undefined for comparison-based capabilities
 */
export const getCapabilityDynamicFieldsForRestore = (selectedCapability, block, items, deviceId) => {
    return getCapabilityConfigByValueType(selectedCapability?.valueType)?.toUi(block, items, deviceId);
};
